module.exports = __webpack_public_path__ + "static/img/wx.1459feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/png/wx.jpg
// module id = gwPF
// module chunks = 1